
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'WYCOOF',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WYCOOF.vue